import { React, reduxConnect } from '../lib/imports';
import Stepper, { Step } from '../common/stepper';
import QuizApp from '../onboarding/QuizApp';
import NameEntry from '../onboarding/NameEntry';
import Success from '../onboarding/Success';
import { setCompletedOnboarding } from '../onboarding/actions';
import Notifications from '../onboarding/Notifications';

const Onboarding = ({
  quizText,
  usernameText,
  notificationsText,
  doneText,
  initialStep,
  handleOnboardingComplete,
  ...props
}) => {
  return (
    <Stepper initialStep={initialStep}>
      <Step bannerText={quizText}>
        <QuizApp />
      </Step>
      <Step bannerText={usernameText}>
        <NameEntry />
      </Step>
      <Step bannerText={notificationsText}>
        <Notifications {...props} />
      </Step>
      <Step bannerText={doneText}>
        <Success />
      </Step>
    </Stepper>
  );
};

const mapStateToProps = (state) => {
  const { strings, onboarding, config } = state;
  const { hasAnswered, hasUsername, hasNotificationPref } = onboarding;

  let step;
  if (!hasAnswered) {
    step = 0;
  } else if (!hasUsername) {
    step = 1;
  } else if (!hasNotificationPref) {
    step = 2;
  } else {
    step = 3;
  }

  return {
    initialStep: step,
    quizText: strings['titles/onboarding/quiz/text'],
    usernameText: strings['titles/onboarding/username/text'],
    notificationsText: strings['titles/onboarding/notifications/text'],
    doneText: strings['titles/onboarding/done/text'],
    config: config,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleOnboardingComplete: (config) => dispatch(setCompletedOnboarding(config)),
  };
};

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Onboarding);
